import type { FilterSection } from "@/types/filterTypes";

export const usePressReleaseFilterSections = (): FilterSection[] => {

  return [
    {
      key: "landingPage",
      label: "Landing Page",
      type: "boolean",
    },
    {
      key: "pressRelease",
      label: "Press Release",
      type: "boolean",
    },
    {
      key: "pressReleaseBanner",
      label: "Press Release Banner",
      type: "boolean",
    },
    {
      key: "createdStartDate",
      label: "Created At Start Date",
      type: "date",
      placeholder: "From"
    },
    {
      key: "createdEndDate",
      label: "Created At End Date",
      type: "date",
      placeholder: "To"
    },
    {
      key: "publishedStartDate",
      label: "Published At Start Date",
      type: "date",
      placeholder: "From"
    },
    {
      key: "publishedEndDate",
      label: "Published At End Date",
      type: "date",
      placeholder: "To"
    }
  ];
};
